export const SET_TOAST = 'SET_TOAST'
export const RESET_TOAST = 'RESET_TOAST'

export default {
  SET_TOAST,
  RESET_TOAST
}
